import { LwBlockGridContainer, LwCard, LwCardProps } from 'redesign';
import { Box, Grid } from '@mui/material';
import { DashboardAnalyticsResponse } from 'api/services/dashboard/dashboard-service.schema';
import { useMemo } from 'react';
import { HeaderComponent } from '../shared/components/header-component';

export const AnalyticsSection = ({ data }: { data: DashboardAnalyticsResponse }) => {
  const mappedData = useMemo(() => analyticsDataMapper(data), [data]);

  return (
    <Box>
      <HeaderComponent titleText="Analytics" downloadUrl="#" />
      <LwBlockGridContainer>
        {mappedData.map((cardData) => (
          <Grid item xs={6} md={6} lg={6} key={cardData.primaryText} aria-label="card-element">
            <LwCard {...cardData} />
          </Grid>
        ))}
      </LwBlockGridContainer>
    </Box>
  );
};

const analyticsDataMapper = (data: DashboardAnalyticsResponse): LwCardProps[] => {
  return [
    {
      primaryText: 'Aanmeldingen',
      status: 'in afwachting',
      subheaderText: 'Komende 14 dagen',
      primaryValue:
        data.applicationsPendingReview === undefined ? '' : `${data.applicationsPendingReview}`,
      secondaryValue:
        data.applicationAverageReactionTime === undefined
          ? ''
          : `${data.applicationAverageReactionTime} dagen`,
      secondaryText: 'Gemiddelde reactietijd',
      threshold: { low: 3, high: 6 },
      isGradient: true,
      isFillRateCard: false,
    },
    {
      primaryText: 'Openstaande checkouts',
      status: '',
      subheaderText: 'Afgelopen 14 dagen',
      primaryValue:
        data.checkoutsPendingReview === undefined ? '' : `${data.checkoutsPendingReview}`,
      secondaryValue:
        data.checkoutsAverageAcceptanceTime === undefined
          ? ''
          : `${data.checkoutsAverageAcceptanceTime} dagen`,
      secondaryText: 'Gemiddelde acceptatietijd',
      threshold: { low: 3, high: 5, thresholdInverted: true },
      isGradient: false,
      isFillRateCard: false,
    },
    {
      primaryText: 'Fill-rate',
      status: 'van aankomende diensten',
      subheaderText: 'Komende 14 dagen',
      primaryValue:
        data.fillRateOfUpcomingShifts === undefined ? '' : `${data.fillRateOfUpcomingShifts}`,
      secondaryValue:
        data.fillRateForFlexPoolWorkers === undefined ? '' : `${data.fillRateForFlexPoolWorkers} %`,
      secondaryText: 'Vanuit de flexpool',
      threshold: { low: 90, high: 97.5 },
      isGradient: false,
      isFillRateCard: true,
    },
    {
      primaryText: 'Dagen',
      status: 'vooruit gepland',
      subheaderText: undefined,
      primaryValue: data.daysPlannedAhead === undefined ? '' : `${data.daysPlannedAhead}`,
      secondaryValue:
        data.medianShiftPublishingWindow === undefined
          ? ''
          : `${data.medianShiftPublishingWindow} dagen`,
      secondaryText: 'Aantal dagen tussen planmomenten',
      threshold: { low: 14, high: 21 },
      isGradient: true,
      isFillRateCard: false,
    },
  ];
};
